import { isAuth } from "../../../helpers/localStoreHandler";

const detailedName = {
  "en": "English",
  "global": "Global",
  "ar-SA": "Saudi Arabia - Arabic",
  "id-ID": "Indonesia - Indonesian",
  "es-US": "United States - Spanish",
  "es-AR": "Argentina - Spanish",
  "th-TH": "Thailand - Thai",
  "pt-BR": "Brazil - Portuguese",
  "pt-PT": "Portugal - Portuguese",
  "en-SA": "Saudi Arabia - English",
  "en-CA": "Canada - English",
  "fr-CA": "Canada - French",
  "ro-RO": "Romania - Romanian",
  "vi-VN": "Vietnam - Vietnamese",
  "en-GB": "United Kingdom - English",
  "es-ES": "Spain - Spanish",
  "es-CL": "Chile - Spanish",
  "es-PE": "Peru - Spanish",
  "en-US": "United States - English",
  "de-DE": "Germany - German",
  "nl-NL": "Netherlands - Dutch",
  "fr-FR": "France - French",
  "es-MX": "Mexico - Spanish",
  "en-IN": "India - English",
  "en-AU": "Australia - English",
  "tr-TR": "Turkey - Turkish",
  "es-UY": "Uruguay - Spanish",
  "el-GR": "Greece - Greek",
  "en-PH": "Philippines - English",
  "nl-BE": "Belgium - Dutch",
  "en-PK": "Pakistan - English",
  "en-ZA": "South Africa - English",
  "it-IT": "Italy - Italian",
  "es-SV": "El Salvador - Spanish",
  "ar-QR": "Qatar - Arabic",
  "en-MY": "Malaysia - English",
  "en-NZ": "New Zealand - English",
  "en-IE": "Ireland - English",
  "en-SG": "Singapore - English",
  "en-HK": "Hong Kong - English",
  "en-KE": "Kenya - English",
  "en-GH": "Ghana - English",
  "en-NG": "Nigeria - English",
  "en-UG": "Uganda - English",
  "en-TZ": "Tanzania - English",
  "en-ZM": "Zambia - English",
  "en-ZW": "Zimbabwe - English",
  "da-DK": "Denmark - Danish",
  "es-CO": "Colombia - Spanish",
  "fi-FI": "Finland - Finnish",
  "fr-BE": "Belgium - French",
  "fr-CH": "Switzerland - French",
  "hu-HU": "Hungary - Hungarian",
  "ja-JP": "Japan - Japanese",
  "ko-KR": "Korea - Korean",
  "no-NO": "Norway - Norwegian",
  "pl-PL": "Poland - Polish",
  "sv-SE": "Sweden - Swedish",
  "uk-UA": "Ukraine - Ukrainian",
  "nn-NO": "Norway - Norwegian Nynorsk",
  "en-TH": "Thailand - English",
  "en-AR": "Argentina - English",
  "en-CL": "Chile - English",
  "en-PE": "Peru - English",
  "ms-MY": "Malaysia - Malay",
  "ar-EG": "Egypt - Arabic",
  "en-EG": "Egypt - English",
  "en-BD": "Bangladesh - English",
  "ar-AE": "United Arab Emirates - Arabic",
  "ar-MA": "Morocco - Arabic",
  "bg-BG": "Bulgaria - Bulgarian",
  "cs-CZ": "Czech Republic - Czech",
  "et-EE": "Estonia - Estonian",
  "de-AT": "Austria - German",
  "de-CH": "Switzerland - German",
  "en-BE": "Belgium - English",
  "en-AE": "United Arab Emirates - English",
  "en-PY": "Paraguay - English",
  "es-BO": "Bolivia - Spanish",
  "es-CR": "Costa Rica - Spanish",
  "es-DO": "Dominican Republic - Spanish",
  "es-GT": "Guatemala - Spanish",
  "es-HN": "Honduras - Spanish",
  "es-NI": "Nicaragua - Spanish",
  "es-PY": "Paraguay - Spanish",
  "es-PR": "Puerto Rico - Spanish",
  "fr-LU": "Luxembourg - French",
  "fr-MA": "Morocco - French",
  "fr-SN": "Senegal - French",
  "it-CH": "Switzerland - Italian",
  "es-DK": "Denmark - Spanish",
  "es-EC": "Ecuador - Spanish",
  "nb-NO": "Norway - Norwegian Nynorsk",
  "si-LK": "Sri Lanka - Sinhala",
  "sk-SK": "Slovakia - Slovak",
  "sl-SI": "Slovenia - Slovenian",
  "zh-CN": "China - Chinese",
  "zh-TW": "Taiwan - Chinese"
}

// Static fallback data
export const brandData = [
  { value: '', label: '' },
  { value: "BH0045", label: "Axe" },
  { value: "BF0917", label: "Bango" },
  { value: "BH0117", label: "Clear" },
  { value: "BH0118", label: "Close up" },
  { value: "BF0204", label: "Continental" },
  { value: "BH0162", label: "Dove" },
  { value: "BF0380", label: "Hellmanns" },
  { value: "BF0426", label: "Knorr" },
  { value: "BH0300", label: "Lifebuoy" },
  { value: "BH0307", label: "Lux" },
  { value: "BH0977", label: "Lynx" },
  { value: "BH0370", label: "Pepsodent" },
  { value: "BH0381", label: "Ponds" },
  { value: "BF0688", label: "Pot noodle" },
  { value: "BH0873", label: "Radox" },
  { value: "BH0413", label: "Rexona" },
  { value: "BF0735", label: "Royco" },
  { value: "BH8837", label: "Sheamoisture" },
  { value: "BH0432", label: "Seda" },
  { value: "BH0433", label: "Sedal" },
  { value: "BH0992", label: "Simple" },
  { value: "BH0468", label: "Sunsilk" },
  { value: "BH0413", label: "Sure Deodorant" },
  { value: "BH0370", label: "Tanya Pepsodent" },
  { value: "BH0996", label: "Tresemme" },
  { value: "BH0499", label: "Vaseline" },
];

export const localeData = [
  { value: '', label: '' },
  { value: "es-ar", label: detailedName["es-AR"] },
  { value: "en-au", label: detailedName["en-AU"] },
  { value: "nl-be", label: detailedName["nl-BE"] },
  { value: "pt-br", label: detailedName["pt-BR"] },
  { value: "en-ca", label: detailedName["en-CA"] },
  { value: "fr-ca", label: detailedName["fr-CA"] },
  { value: "es-cl", label: detailedName["es-CL"] },
  { value: "fr-fr", label: detailedName["fr-FR"] },
  { value: "de-de", label: detailedName["de-DE"] },
  { value: "el-gr", label: detailedName["el-GR"] },
  { value: "en-in", label: detailedName["en-IN"] },
  { value: "en-id", label: detailedName["en-ID"] },
  { value: "id-id", label: detailedName["id-ID"] },
  { value: "it-it", label: detailedName["it-IT"] },
  { value: "es-mx", label: detailedName["es-MX"] },
  { value: "es-pe", label: detailedName["es-PE"] },
  { value: "en-ph", label: detailedName["en-PH"] },
  { value: "en-za", label: detailedName["en-ZA"] },
  { value: "th-th", label: detailedName["th-TH"] },
  { value: "tr-tr", label: detailedName["tr-TR"] },
  { value: "en-gb", label: detailedName["en-GB"] },
  { value: "es-uy", label: detailedName["es-UY"] },
  { value: "vi-vn", label: detailedName["vi-VN"] },
  { value: "nl-nl", label: detailedName["nl-NL"] },
  { value: "ro-ro", label: detailedName["ro-RO"] },
  { value: "pt-pt", label: detailedName["pt-PT"] },
];

// Environment configuration
const isProd = window.location.host === 'toolbox.kritique.io';
let baseURL_PROD = `https://vibes-dev.unileversolutions.com`;
// let xApiKey = process.env.REACT_APP_BMP_X_API_KEY;
if (isProd) {
  baseURL_PROD = process.env.REACT_APP_BMP_BASE_URL_PROD;
  // xApiKey = process.env.REACT_APP_BMP_X_API_KEY_PROD;
}

// API fetch function
const fetchBrandLocaleData = async () => {
  const response = await fetch(`${baseURL_PROD}/v2/kritique/bmp/api/brands`, {
    headers: {
      // 'x-api-key': xApiKey,
      "x-token": isAuth(),
      "Content-Type": "application/json"
    },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch brand metadata');
  }
  const data = await response.json();
  return data;
};

// Transform API data to dropdown format
const transformBrandMetadata = (apiData) => {
  // Filter out US markets and process data
  const filteredData = apiData.data.filter(item => item.market !== 'US');
  
  // Create brand-locale mapping
  const brandLocaleMap = new Map();
  
  filteredData.forEach(item => {
    const brandKey = item?.brand_code;
    let brdName = item?.brand_code === "BF0101" ? item.brand : item.bg_brand;
    if (brandKey === "BF0735" || brandKey === "BF0204" || brandKey === 'BH0432' || brandKey === 'BH0433') {
      const host = new URL(item?.gsc_domain_url)?.hostname;
      brdName = host?.replace('www.', '')?.split('.')?.[0];
    }
    let brandLabel = brdName ? brdName.charAt(0).toUpperCase() + brdName.slice(1) : item.brand.charAt(0).toUpperCase() + item.brand.slice(1);
    if (brandKey === "BH0413") {
      brandLabel = `${brandLabel} / Sure Deodorant`;
    }
    if (!brandLocaleMap.has(brandKey)) {
      brandLocaleMap.set(brandKey, {
        brand: { value: brandKey, label: brandLabel },
        locales: new Set()
      });
    }
    
    brandLocaleMap.get(brandKey).locales.add(item.locale);
  });
  
  // Transform to dropdown format
  const brands = [{ value: '', label: '' }];
  const brandLocales = {};
  
  brandLocaleMap.forEach((data, brandCode) => {
    brands.push(data.brand);
    brandLocales[brandCode] = [
      { value: '', label: '' },
      ...Array.from(data.locales).map(locale => ({
        value: locale.toLowerCase(),
        label: detailedName[locale] || locale
      }))
    ];
  });
  
  return { brands, brandLocales };
};

// Main function to get brand and locale data
export const getBrandLocaleData = async () => {
  try {
    const apiData = await fetchBrandLocaleData();
    const { brands, brandLocales } = transformBrandMetadata(apiData);
    
    return {
      success: true,
      brands,
      brandLocales,
      isFromAPI: true
    };
  } catch (error) {
    
    // Create static brand-locale mapping for fallback
    const staticBrandLocales = {};
    brandData.forEach(brand => {
      if (brand.value) {
        staticBrandLocales[brand.value] = localeData;
      }
    });
    
    return {
      success: false,
      brands: brandData,
      brandLocales: staticBrandLocales,
      isFromAPI: false,
      error: error.message
    };
  }
};

// Helper function to get locales for a specific brand
export const getLocalesForBrand = (brandCode, brandLocales) => {
  return brandLocales[brandCode] || [{ value: '', label: '' }];
};

// Initialize data fetch (optional - can be called from components)
export const initializeBrandLocaleData = async () => {
  return await getBrandLocaleData();
};